import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CardError, CardList, Loading } from '../../components';
import { gethealthInsurance } from '../../redux/actions/healthInsuranceActions';

const HealthInsuranceScreen = () => {
  const dispatch = useDispatch();
  const { healthInsurances, isLoading } = useSelector((state) => state.healthInsuranceReducer);
  const { doctor } = useSelector((state) => state.doctorReducer);

  useEffect(() => {
    dispatch(gethealthInsurance(doctor.id));
  }, []);

  if (isLoading) return <Loading />;

  if (healthInsurances?.length === 0) return <CardError text="No hay obras sociales" />;

  return (
    <div>
      <CardList data={healthInsurances?.filter((obraSocial) => !obraSocial.abacus_only)} type="health" title="Elija una obra social" />
    </div>

  );
};

export default HealthInsuranceScreen;
